<template>
  <PopUp
    :show="show"
    @cancel="handleCancel">
    <template v-slot:header>
      <p class="title-text">Save New Report</p>
    </template>
    <template v-slot:content>
      <div>
        <p class="content-text">
          This action will save this report as a <b>new report</b> to the Saved Reports list.
          This report will be visible to any one
          who has access to the brand associated with this report.
        </p>
        <HelperTextInput
          v-model="reportName"
          name="report-name"
          label="Report Name"
          :required="required && !reportName"
          :error="error"
        ></HelperTextInput>
      </div>
    </template>
    <template v-slot:customActions>
      <div class="cancel-button">
        <SecondaryButton @click="handleCancel">Cancel</SecondaryButton>
      </div>
      <div class="save-buttons">
        <SecondaryButton @click="handleSaveAndSchedule">Save and Schedule</SecondaryButton>
        <PrimaryButton @click="handleSaveOnly">Save Only</PrimaryButton>
      </div>
    </template>
  </PopUp>
</template>

<script>
import {
  PopUp,
  PrimaryButton,
  SecondaryButton,
  HelperTextInput,
} from '@mikmak/components';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    PopUp,
    PrimaryButton,
    SecondaryButton,
    HelperTextInput,
  },
  data() {
    return {
      reportName: '',
      error: '',
    };
  },
  methods: {
    resetReportName() {
      this.reportName = '';
    },
    clearError() {
      this.error = '';
    },
    isValidateReportName() {
      if (this.reportName === '') {
        this.error = 'A report name is required.';

        return false;
      }

      return true;
    },
    handleSaveOnly() {
      if (!this.isValidateReportName()) {
        return;
      }

      this.clearError();
      this.$emit('saveReportOnly', { reportName: this.reportName });
      this.resetReportName();
    },
    handleSaveAndSchedule() {
      if (!this.isValidateReportName()) {
        return;
      }

      this.clearError();
      this.$emit('saveAndSchedule', { reportName: this.reportName });
      this.resetReportName();
    },
    handleCancel() {
      this.clearError();
      this.$emit('toggleSaveReportPopUp');
      this.resetReportName();
    },
  },
};
</script>

<style scoped lang="scss">
.pop-up::v-deep {
  .actions-wrapper {
    background: white;
  }

  .modal {
    max-width: 600px;
    max-height: 294px;
    box-sizing: border-box;
  }

  .wrapper {
    min-height: 60px;
  }
}

.cancel-button {
  float: left;
}

.content-text {
  margin-top: 12px;
}

.save-buttons {
  float: right;
}

.title-text {
  font-weight: 700;
  height: 34px;
  line-height: 34px;
  margin: 0;
}
</style>
